export default __webpack_public_path__ + "static/media/login.7923a9d5.png";